import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-modelvideo2',
  templateUrl: './modelvideo2.component.html',
  styleUrls: ['./modelvideo2.component.scss']
})
export class Modelvideo2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
